// extracted by mini-css-extract-plugin
export default {"statusContainer":"Status_statusContainer__YTNdT","eventName":"Status_eventName__n0Ek3"};